/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ImageLinkItem } from "./image-link-item";
import { CarouselWithNav } from "cms/shared/carousel-with-nav";

const ImageLinkComponent = (props) => {

    const component = props?.component;
    const imageList = component?.image_list;
    const sectionName = component?.sectionName;

    const hasImageList = imageList && imageList.length > 0;
    const imageLinkItemWidth = 220;

    const renderImageLinkItem = (imageLinkItem) => {
        return <ImageLinkItem item={imageLinkItem} />;
    };

    return (
        <div className='simplicity-image-link'>
            {sectionName && <h4>{sectionName}</h4>}
            {hasImageList &&
                <CarouselWithNav
                    carouselItemList={imageList}
                    carouselItemWidth={imageLinkItemWidth}
                    renderCarouselItem={renderImageLinkItem}
                />
            }
        </div>
    );
};

ImageLinkComponent.displayName = "ImageLinkComponent";
export { ImageLinkComponent };
